import {
  Route,
  Routes,
  Navigate,
} from 'react-router';

import {
  NavigationTabs,
  ContentWrapper,
  PaymentsDetails,
  IdeafitPayments,
  PaymentsInvoices,
} from 'web-components';

import {
  Flex,
} from 'web-styled';
import {
  getNamespaceSymbol,
} from 'web-utils';

import StripeConnected from './StripeConnected';

const tabs = [
  {
    name: 'Transaction History',
    to: '/payments/transactions',
  },
  {
    name: 'Payment Details',
    to: '/payments/details',
  },
];

const namespaceSymbol = getNamespaceSymbol() || 'gymcloud';

const PaymentsPage = () => {
  const Details = namespaceSymbol == 'ideafit' ? IdeafitPayments : PaymentsDetails
  return (
    <ContentWrapper
      header={(
        <Flex
          fillSpace
          align="center"
        >
          <NavigationTabs
            tabs={tabs}
          />
        </Flex>
      )}
    >
      <Routes>
        <Route
          index
          element={<Navigate to="transactions" replace />}
        />
        <Route
          path="transactions"
          Component={PaymentsInvoices}
        />
        <Route
          path="details"
          Component={Details}
        />
        <Route
          path="stripe-connected"
          Component={StripeConnected}
        />
      </Routes>
    </ContentWrapper>
  );
};

export default PaymentsPage;
